import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from './api/axios'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './assets/style/reset.css';
import './assets/style/common.css';
import './assets/icon/aliProject.css';
import VueClipboard from 'vue-clipboard2'

Vue.use(ElementUI);
Vue.use(VueClipboard)

router.beforeEach((to, from, next) => {
  // 路由跳转后，让页面回到顶部
  // chrome
  if (to.query.inoScrollTop) {
    next();
    return
  }
  document.body.scrollTop = 0; // firefox
  document.documentElement.scrollTop = 0; // safari
  window.pageYOffset = 0; // 调用 next()，一定要调用 next 方法，否则钩子就不会被销毁
  next();
  //to 即将进入的路由
  //from 即将离开的路由
  //next 放行
});
Vue.config.productionTip = false

new Vue({
  router,
  axios,
  store,
  render: h => h(App)
}).$mount('#app')
